import { useEffect, useRef } from "react";
import type { HomeViewMode } from "shared";
import { trackAiHome } from "./aiHomeEvents";
import {
  armAiHomeSessionEnd,
  getAiHomeSession,
  markAiHomeSessionEnded,
} from "./aiHomeSession";

export const useAiHomeSessionTracker = (mode: HomeViewMode) => {
  const modeRef = useRef(mode);

  useEffect(() => {
    modeRef.current = mode;
  }, [mode]);

  useEffect(() => {
    const endSession = () => {
      if (!markAiHomeSessionEnded()) return;

      const session = getAiHomeSession();
      trackAiHome(
        "ai_session_ended",
        {
          screen_mode_at_exit: modeRef.current,
          total_queries: session.queryCount,
          total_chats_opened: session.chatsOpened,
          session_duration_ms: Date.now() - session.startedAt,
          last_action: session.lastAction,
        },
        { transport: "sendBeacon" },
      );
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        endSession();
        return;
      }
      armAiHomeSessionEnd();
    };

    window.addEventListener("pagehide", endSession);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("pagehide", endSession);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
};
